import { useTranslation } from 'react-i18next';
import type { ViewMode } from '@/types/common.types';

interface ViewToggleProps {
  view: ViewMode;
  onViewChange: (v: ViewMode) => void;
}

export function ViewToggle({ view, onViewChange }: ViewToggleProps) {
  const { t } = useTranslation();
  return (
    <div className="tpl-view-toggle">
      <button
        className={`tpl-vt-btn${view === 'cards' ? ' active' : ''}`}
        onClick={() => onViewChange('cards')}
        title={t('common.viewCards')}
        aria-label={t('common.viewCards')}
      >
        <i className="fas fa-th-large" aria-hidden="true" />
      </button>
      <button
        className={`tpl-vt-btn${view === 'list' ? ' active' : ''}`}
        onClick={() => onViewChange('list')}
        title={t('common.viewList')}
        aria-label={t('common.viewList')}
      >
        <i className="fas fa-list" aria-hidden="true" />
      </button>
    </div>
  );
}
